<script lang="ts" setup>

</script>

<template>
  <div class="loading-wrap">
    <div class="balls">
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<style scoped>
.loading-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	height: auto;
	width: 100%;
}

.balls {
	width: 4rem;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: space-between;
}

.balls div {
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 50%;
	background-color: #764ab9;
}

.balls div:nth-of-type(1) {
	transform: translateX(-100%);
	animation: left-swing 0.5s ease-in alternate infinite;
}

.balls div:nth-of-type(3) {
	transform: translateX(-95%);
	animation: right-swing 0.5s ease-out alternate infinite;
}

@keyframes left-swing {

	50%,
	100% {
		transform: translateX(95%);
	}
}

@keyframes right-swing {
	50% {
		transform: translateX(-95%);
	}

	100% {
		transform: translateX(100%);
	}
}

@media (prefers-color-scheme: dark) {
	body {
		background: #121212;
	}
}
</style>
